import { signalStore, withMethods, withState } from "@ngrx/signals";

import { Employee } from "@mes-slalom/ui-common-lib";
import { updateState, withStoreDevtools } from "./store-devtools.feature";

export interface CoreState {
  user: Employee | null;
  securityRoles: string[];
  isAuthenticated: boolean;
  loadingCount: number; // legacy / auth-related
  networkLoading: number; // general API calls
}

const initialState: CoreState = {
  user: null,
  securityRoles: [],
  isAuthenticated: false,
  loadingCount: 0,
  networkLoading: 0,
};

export const CoreStore = signalStore(
  { providedIn: "root" },
  withState(initialState),
  withStoreDevtools("CoreStore"),
  withMethods((store) => ({
    setUser(user: any): void {
      updateState(store, "[CoreStore] setUser", { user });
    },
    setSecurityRoles(roles: string[]): void {
      updateState(store, "[CoreStore] setSecurityRoles", {
        securityRoles: roles,
      });
    },
    beginLoading(): void {
      updateState(store, "[CoreStore] beginLoading", {
        loadingCount: store.loadingCount() + 1,
      });
    },
    endLoading(): void {
      const next = Math.max(0, store.loadingCount() - 1);
      updateState(store, "[CoreStore] endLoading", { loadingCount: next });
    },
    beginNetwork(): void {
      updateState(store, "[CoreStore] beginNetwork", {
        networkLoading: store.networkLoading() + 1,
      });
    },
    endNetwork(): void {
      const next = Math.max(0, store.networkLoading() - 1);
      updateState(store, "[CoreStore] endNetwork", { networkLoading: next });
    },
    resetLoading(): void {
      updateState(store, "[CoreStore] resetLoading", {
        loadingCount: 0,
        networkLoading: 0,
      });
    },
  }))
);
